export enum OptimizelyExperiments {
  isSupportAssistantEnabled = 'opex_support_assistant_customer_pool',
  emailChangeEnabled = 'opex_email_change',
  securePhoneNumberChangeEnabled = 'csx_secure_phone_number_change',
  croLPFreePreviewAfterSignUpLogIn = 'cro_offer_lp_free_preview_after_sign_up_log_in',
  croAlwaysOnNewMobileBooking = 'cro_lpc_new_mobile_booking',
  croFlexibleFlightFares = 'cro_flexible_flight_fares',
  paymentsDepositOptionForHotelsAbove1999V2 = 'payments_deposit_option_for_hotels_above_1999_v2',
  paymentsLpc50PercentDepositSchedule = 'payments_lpc_50_percent_deposit_schedule',
  paymentsLpp50PercentDepositSchedule = 'payments_lpp_50_percent_deposit_schedule',
  carHireBundledDiscountUpcomingOrderHomepageCarousel = 'car_hire_bundled_discount_upcoming_order_homepage_carousel',
  croPopularOptionBookingRemaining = 'cro_popular_option_booking_remaining',
  growthShowOfferUrgencyCountdownLabel = 'growth_force_show_offer_urgency_countdown_label',
  croBundledFlexibleFlightFaresV2 = 'cro_bundled_flexible_flight_fares_v2',
  croHideHomepageSearchEmergingMarkets = 'cro_hide_homepage_search_emerging_markets',
  lereNonAUTwoTowersHomePageHeroCarouselV2 = 'lere_non_au_two_towers_home_page_hero_carousel_v2',
  lerePersonalisedHomePageHeroCarousel = 'lere_personalised_home_page_hero_carousel',
  lerePersonalisedHomePageHeroCarouselV4 = 'lere_home_page_carousel_v4',
  lerePersonalisedHomePageHeroCarouselV5 = 'lere_home_page_carousel_v5',
  croPrefetchInflowCheckoutExperiences = 'cro_prefetch_inflow_checkout_experiences',
  croPrefetchFlightsFromOffer = 'cro_prefetch_flights_from_offer',
  croOfferCtaSeeDeal = 'cro_offer_cta_see_deal',
  carHireObjectiveIntentMessage = 'car_hire_objective_intent_message',
  croFlexCfmrBedbankPackages = 'cro_flex_cfmr_bedbank_packages',
  growthMetasearchPerNightPricing = 'growth_metasearch_per_night_pricing',
  croPricePerNightToggleOnSearch = 'cro_price_per_night_toggle_on_search',
  croOrderDownloadPdf = 'cro_order_download_pdf',
  cruiseAutoFocusNextFilter = 'cruise_auto_focus_next_filter',
  cruiseMpvRanking = 'cruise_mpv_ranking',
  cruiseOfferPageEarlyTravellerSelection = 'cruise_offer_page_early_traveller_selection',
  labnableVideoBackground = 'lab_enable_video_background',
  loyaltyCommSubBonus = 'loyalty_communication_resubscription_bonus',
  croRentalsDefaultToSplitMapSearch = 'cro_rentals_default_to_split_map_search',
  navHomesVillasBeforeMaldivesBundles = 'nav_homes_villas_before_maldives_bundles',
  growthPaidOfferGalleryVariant = 'growth_paid_offer_gallery_variant',
  croTrustIndicatorsSearchPageV2 = 'cro_trust_indicators_search_page_v2',
  croTrustpilotReviewFeedInOfferPage = 'cro_trustpilot_review_feed_in_offer_page',
  croCaptureBouncingCustomersWithYamlModalV2 = 'cro_capture_bouncing_customers_with_yaml_modal_v2',
  croPopularFlightsHomePage = 'cro_popular_flights_home_page',
  croDisplayLtleOnHomepage = 'cro_display_ltle_on_homepage',
  lereRankerClustering = 'lere_ranker_clustering',
  experiencesCollections = 'experiences_collections',
  croCheckoutProgressStepper = 'cro_checkout_progress_stepper',
  opexLESAEmptyChatFreeText = 'opex_lesa_empty_chat_free_text_ab_test',
  opexLesaNlsOffersCarousel = 'opex_lesa_nls_offers_carousel_ab_test',
  opexLesaV2Assistant = 'opex_lesa_v2_assistant_ab_test',
  croChildrenStayFreeTag = 'cro_children_stay_free_tag',
  opexBookingAuthorityReferralBannerAbTest = 'opex_booking_authority_referral_banner_ab_test_v2',
  // Funnel optimiser A/B tests (see src/checkout/selectors/funnel.ts for usage)
  funnelOptimiserRuleId16 = 'funnel_optimiser_ruleid_16',
  funnelOptimiserRuleId17 = 'funnel_optimiser_ruleid_17',
  funnelOptimiserRuleId18 = 'funnel_optimiser_ruleid_18',
  croTierProgressionOfferPage = 'cro_tier_progression_offer_page',
  croShareSocietePoints = 'cro_share_societe_points',
  croExpressCheckoutAutoDefault = 'cro_express_checkout_auto_default',
  croCheckoutIncompleteInformationModal = 'cro_checkout_incomplete_information_modal',
  seoStaticHotelsDynamicResolveAb = 'seo_static_hotels_dynamic_resolve_ab',
  croInsuranceTestimonials = 'cro_insurance_testimonials',
  luxPlusReconsiderCheckoutBanner = 'lux_plus_reconsider_checkout_banner',
  croLppCustomContentV2 = 'cro_lpp_custom_content_v2',
  croPackageRecommendationApi = 'cro_package_recommendation_api',
  lereBedbankSimilarOffer = 'lere_bedbank_similar_offer',
  searchNlsLlmRerank = 'search_nls_llm_rerank',
  /** Metasearch YMAL secondary offers: show user's incoming check-in/check-out dates and dated pricing for LPC/LPP tiles (Flash continues to render package pricing). */
  growthMetasearchYmalDatedSecondaryOffers = 'growth_metasearch_ymal_dated_secondary_offers',
  croSuggestedPackageHighInMobilePage = 'cro_suggested_package_high_in_mobile_page',
  mobileWebOfferPageFlashCalendarSkip = 'mobile_web_offer_page_flash_calendar_skip',
  /** Checkout: optional guest traveller cards (instant hotel/bedbank) */
  opexCheckoutOptionalGuestTravellerForms = 'opex_checkout_optional_guest_traveller_forms',
  /** Checkout: share booking checkbox on traveller cards (control vs on) */
  opexCheckoutTravellerCardShareBooking = 'opex_checkout_traveller_card_share_booking',
  croCheckoutCancellationPolicyTimeline = 'cro_checkout_cancellation_policy_timeline_2',
  internationalCheckoutFlow = 'international_checkout_flow',
  loyaltySocieteBurn = 'loyalty_societe_burn',
  searchSalesCtrPaidTrafficRanking = 'search_sales_ctr_paid_traffic_ranking',
  searchLowViewDestinationsSalesCtrRanking = 'search_low_view_destinations_sales_ctr_ranking',
  croOfferPageHighlightTags = 'cro_offer_page_highlight_tags',
  croRefundPolicyRadioBtnsBelowInclusions = 'cro_refund_policy_radio_btns_below_inclusions',
  croNewFlightUpsellTest = 'cro_new_flight_upsell_test',
  croMobileWebPackageSelectCta = 'cro_mobile_web_package_select_cta',
  sppIncludeBundles = 'spp_include_bundles',
  nhaHomesAndVillasToggleInSearch = 'nha_homes_and_villas_toggle_in_search',
  searchTilePropertyNearby = 'search_tile_property_nearby',
  croOfferNearbyLocations = 'cro_offer_nearby_locations_2',
  /** Mobile web compact hotel/accommodation search tiles for Google CPC + organic */
  commsCompactMobileSearchTile = 'comms_compact_mobile_search_tile',
  sppBedbankPromos = 'spp_bedbank_promos',
  croMobileWebOfferHeader = 'cro_mobile_web_offer_header',
  croPcmTestimonialOnOfferPage = 'cro_pcm_testimonial_on_offer_page',
  tripAiTripPlannerOnFlightsPage = 'trip_ai_trip_planner_on_flights_page',
  croSocialProofRecentPurchase = 'cro_social_proof_recent_purchase',
  lereEndingSoonRanker = 'lere_ending_soon_ranker',
  croOneClickBookingRestoration = 'cro_one_click_booking_restoration',
}

// ---------------------------------------------------------------------------
// Experiment Configs — type-safe experiment definitions
// ---------------------------------------------------------------------------
//
// When adding a new experiment, define its config here. The `variations` tuple
// tells TypeScript exactly which variation strings are valid. The `useExperiment`
// hook uses this to narrow the returned `variation` field so you get
// autocomplete and compile-time errors if you check for a variation that
// doesn't exist.
//
// Common variation patterns:
//   - Standard A/B:    ['control', 'on'] DEFAULT
//   - Multi-variant:   ['control', 'variant_1', 'variant_2']
// ---------------------------------------------------------------------------

/**
 * A type-safe experiment configuration that links an experiment ID
 * to its known variation strings.
 */
export interface ExperimentConfig<
  TId extends OptimizelyExperiments = OptimizelyExperiments,
  TVars extends ReadonlyArray<string> = ReadonlyArray<string>,
> {
  /** The experiment ID (must be a member of OptimizelyExperiments). */
  readonly id: TId
  /** The exhaustive list of variation strings for this experiment. */
  readonly variations: TVars
}

/** Default variations for standard A/B experiments. */
const DEFAULT_VARIATIONS = ['control', 'on'] as const

/** Helper to create an ExperimentConfig with full type inference. */
function defineExperiment<
  TId extends OptimizelyExperiments,
  const TVars extends ReadonlyArray<string>,
>(id: TId, variations: TVars): ExperimentConfig<TId, TVars>
function defineExperiment<TId extends OptimizelyExperiments>(id: TId): ExperimentConfig<TId, typeof DEFAULT_VARIATIONS>
function defineExperiment<
  TId extends OptimizelyExperiments,
  const TVars extends ReadonlyArray<string>,
>(id: TId, variations?: TVars) {
  return { id, variations: variations ?? DEFAULT_VARIATIONS }
}

/**
 * Type-safe experiment configs.
 *
 * Pass these to `useExperiment()` instead of raw `OptimizelyExperiments` enum
 * values to get typed `variation` in the result — preventing typos and making
 * exhaustive checks possible.
 *
 * Variations default to `['control', 'on']`. Only specify variations when the
 * experiment uses non-standard ones (e.g. multi-variant).
 *
 * Usage:
 * ```ts
 * // Standard A/B — variations default to ['control', 'on']
 * const { isAnyVariant } = useExperiment(Experiments.myExperiment)
 *
 * // Multi-variant — specify variations explicitly
 * const { variation } = useExperiment(Experiments.myMultiVariant)
 * // variation: 'control' | 'variant_a' | 'variant_b' | undefined
 * ```
 */
export const Experiments = {
  croTrustIndicatorsSearchPageV2: defineExperiment(OptimizelyExperiments.croTrustIndicatorsSearchPageV2),
  croShareSocietePoints: defineExperiment(OptimizelyExperiments.croShareSocietePoints, ['control', 'variant_10', 'variant_50'] as const),
  croOfferCtaSeeDeal: defineExperiment(
    OptimizelyExperiments.croOfferCtaSeeDeal,
    ['control', 'variant'] as const,
  ),
  croExpressCheckoutAutoDefault: defineExperiment(OptimizelyExperiments.croExpressCheckoutAutoDefault),
  croCheckoutIncompleteInformationModal: defineExperiment(OptimizelyExperiments.croCheckoutIncompleteInformationModal),
  croInsuranceTestimonials: defineExperiment(OptimizelyExperiments.croInsuranceTestimonials),
  luxPlusReconsiderCheckoutBanner: defineExperiment(OptimizelyExperiments.luxPlusReconsiderCheckoutBanner),
  croLppCustomContentV2: defineExperiment(OptimizelyExperiments.croLppCustomContentV2),
  croPackageRecommendationApi: defineExperiment(OptimizelyExperiments.croPackageRecommendationApi),
  croDisplayLtleOnHomepage: defineExperiment(OptimizelyExperiments.croDisplayLtleOnHomepage),
  paymentsLpc50PercentDepositSchedule: defineExperiment(OptimizelyExperiments.paymentsLpc50PercentDepositSchedule),
  lereBedbankSimilarOffer: defineExperiment(OptimizelyExperiments.lereBedbankSimilarOffer),
  growthMetasearchYmalDatedSecondaryOffers: defineExperiment(OptimizelyExperiments.growthMetasearchYmalDatedSecondaryOffers),
  croSuggestedPackageHighInMobilePage: defineExperiment(OptimizelyExperiments.croSuggestedPackageHighInMobilePage),
  opexLesaV2Assistant: defineExperiment(
    OptimizelyExperiments.opexLesaV2Assistant,
    ['V1', 'V2'] as const,
  ),
  opexLesaNlsOffersCarousel: defineExperiment(OptimizelyExperiments.opexLesaNlsOffersCarousel),
  mobileWebOfferPageFlashCalendarSkip: defineExperiment(OptimizelyExperiments.mobileWebOfferPageFlashCalendarSkip),
  cruiseOfferPageEarlyTravellerSelection: defineExperiment(OptimizelyExperiments.cruiseOfferPageEarlyTravellerSelection),
  opexCheckoutOptionalGuestTravellerForms: defineExperiment(OptimizelyExperiments.opexCheckoutOptionalGuestTravellerForms),
  opexCheckoutTravellerCardShareBooking: defineExperiment(OptimizelyExperiments.opexCheckoutTravellerCardShareBooking),
  croCheckoutCancellationPolicyTimeline: defineExperiment(OptimizelyExperiments.croCheckoutCancellationPolicyTimeline),
  croNewFlightUpsellTest: defineExperiment(OptimizelyExperiments.croNewFlightUpsellTest),
  internationalCheckoutFlow: defineExperiment(OptimizelyExperiments.internationalCheckoutFlow),
  paymentsLpp50PercentDepositSchedule: defineExperiment(OptimizelyExperiments.paymentsLpp50PercentDepositSchedule),
  croCheckoutProgressStepper: defineExperiment(OptimizelyExperiments.croCheckoutProgressStepper),
  croPricePerNightToggleOnSearch: defineExperiment(OptimizelyExperiments.croPricePerNightToggleOnSearch),
  /**
   * Controls visibility of the points burn UI on search results pages (toggle + slider).
   * This does NOT affect points burn at checkout, which has its own separate enablement logic.
   */
  loyaltySocieteBurn: defineExperiment(OptimizelyExperiments.loyaltySocieteBurn),
  searchSalesCtrPaidTrafficRanking: defineExperiment(OptimizelyExperiments.searchSalesCtrPaidTrafficRanking),
  searchLowViewDestinationsSalesCtrRanking: defineExperiment(OptimizelyExperiments.searchLowViewDestinationsSalesCtrRanking),
  croOfferPageHighlightTags: defineExperiment(OptimizelyExperiments.croOfferPageHighlightTags),
  croRefundPolicyRadioBtnsBelowInclusions: defineExperiment(OptimizelyExperiments.croRefundPolicyRadioBtnsBelowInclusions),
  croMobileWebPackageSelectCta: defineExperiment(OptimizelyExperiments.croMobileWebPackageSelectCta),
  sppIncludeBundles: defineExperiment(OptimizelyExperiments.sppIncludeBundles),
  nhaHomesAndVillasToggleInSearch: defineExperiment(OptimizelyExperiments.nhaHomesAndVillasToggleInSearch),
  searchTilePropertyNearby: defineExperiment(OptimizelyExperiments.searchTilePropertyNearby),
  croOfferNearbyLocations: defineExperiment(OptimizelyExperiments.croOfferNearbyLocations),
  commsCompactMobileSearchTile: defineExperiment(OptimizelyExperiments.commsCompactMobileSearchTile),
  sppBedbankPromos: defineExperiment(OptimizelyExperiments.sppBedbankPromos),
  tripAiTripPlannerOnFlightsPage: defineExperiment(OptimizelyExperiments.tripAiTripPlannerOnFlightsPage),
  croMobileWebOfferHeader: defineExperiment(OptimizelyExperiments.croMobileWebOfferHeader),
  croPcmTestimonialOnOfferPage: defineExperiment(OptimizelyExperiments.croPcmTestimonialOnOfferPage),
  croSocialProofRecentPurchase: defineExperiment(OptimizelyExperiments.croSocialProofRecentPurchase),
  lereEndingSoonRanker: defineExperiment(OptimizelyExperiments.lereEndingSoonRanker),
  croOneClickBookingRestoration: defineExperiment(OptimizelyExperiments.croOneClickBookingRestoration),
} as const

export enum OptimizelyFeatureFlags {
  luxLoyaltyFeatureToggle = 'lux_loyalty_feature_toggle',
  luxPlusFeatureToggle = 'luxplus_feature_toggle',
  luxPlusToursToggle = 'luxplus_tours_toggle',
  luxPlusDiscountedInsuranceBenefit = 'lux_plus_discounted_insurance_benefit',
  luxPlusDiscountedBookingProtectionBenefit = 'lux_plus_discounted_booking_protection_benefit',
  luxPlusLppPricingEnabled = 'luxplus_lpp_pricing_enabled',
  luxPlusCruiseInclusionsEnabled = 'lux_plus_cruise_inclusions',
  luxPlusDiscountedCruise = 'lux_plus_discounted_cruise',
  luxPlusDiscountedExperiencesBenefit = 'lux_plus_discounted_experiences_benefit',
  allowPhoneNumberLogin = 'allow_phone_number_login',
  promoAppBanner = 'app_banner_targeted_delivery',
  CSAgentsAutoQuote = 'cro_cs_agents_auto_quote',
  toursRequestAgentCallbackEnabled = 'csx_tours_request_agent_callback',
  hotelsAndVillasRequestAgentCallbackEnabled = 'csx_hotels_and_villas_request_agent_callback',
  upsellTilesFeatureToggle = 'cro_upsell_on_homepage_and_my_escapes',
  croTravelPreferencesModalEnabled = 'cro_travel_preferences_modal',
  opexTermsAndConditionsModal = 'terms_and_conditions_modal',
  croWebPushNotificationPrompt = 'cro_web_push_notification_prompt',
  opexFraudOrdersOtp = 'opex_fraud_orders_otp',
  payIdTargetedRelease = 'pay_id_targeted_release',
  carHireBundledDiscount = 'car_hire_bundled_discount',
  lereDestinationModelEnabled = 'lere_personalised_destinations',
  lereOfferPageRecommendationsEnabled = 'lere_offer_page',
  lereHeroCarouselEnabled = 'lere_hero_carousel',
  opexHotelAddExtraGuestsEnabled = 'hotel_add_extra_guests',
  opexLPCAddExtraGuestsEnabled = 'lpc_add_extra_guests',
  flightsEnableSabreContent = 'flights_enable_sabre_content',
  flightsLuxPlusPricing = 'flights_lux_plus_pricing',
  loyaltyLuxPlusRenewalReward = 'loyalty_lux_plus_renewal_reward',
  loyaltyPointsDeductionWarning = 'loyal_points_deduction_warning',
  croInsuranceXCoverEnabled = 'cro_insurance_xcover_enabled',
  croPayAtProperty = 'cro_pay_at_property',
  croPackageUpgradeLibEnabled = 'cro_package_upgrade_lib_enabled',
  standaloneFlightLoungePassExperiencesEnabled = 'standalone_flight_lounge_pass_experiences_enabled',
  merchandiseLaunch = 'merchandise_launch',
  loyaltyPurchasePointsEnabled = 'loyalty_points_purchase',
  opexBookingAuthority = 'opex_booking_authority',
  opexLESAConditionalBubble = 'opex_lesa_conditional_bubble',
  opexBookingAuthorityManageAccess = 'opex_booking_authority_manage_access',
  luxRow = 'lux_row',
  maldivesCharterRewardSeats = 'maldives_charter_reward_seats',
  croWrappedModalTravelled = 'cro_wrapped_modal',
  croWrappedModalAll = 'cro_wrapped_modal_all',
  croDisplaySimilarAccounts = 'cro_display_similar_accounts',
  randomizeExperiencesOffers = 'randomize_experiences_offers',
  flightsDateGrid = 'flights_date_grid',
  flightsDateGridStandalone = 'flights_date_grid_standalone',
  disallowPartialFlightsSeatSelection = 'disallow_partial_flights_seat_selection',
  loyaltyLuxplusLandingPage = 'loyalty_luxplus_landing_page',
  childrenFlyFree = 'children_fly_free',
  flightsPriceAlerts = 'flights_price_alerts',
  croPassportCardExclusiveCheckout = 'cro_passport_card_exclusive_checkout',
  loyaltyEsimBenefit = 'loyalty_esim_benefit',
  searchTypeaheadGeoTypeIndexed = 'search_typeahead_geo_type_indexed',
  croOnlyInAustraliaCarousel = 'cro_only_in_australia_carousel',
  flightsFareSense = 'flights_fare_sense',
  opexBookAgain = 'opex_book_again',
  opexSelfServiceNameChange = 'opex_self_service_name_change',
  aiOpsSpoofLaunchPadWhitelist = 'ai-ops-spoof-launch-pad-whitelist',
  leLivePopup = 'le_live_popup',
  experiencesSearchAttractions = 'experiences_search_attractions',
  maldivesCharterFnfPage = 'maldives_charter_fnf_page',
  charterLaunchOffer100 = 'charter_launch_offer_100',
  noPlaceLikeHomeCampaign = 'no_place_like_home_campaign',
  sppUpliftLpcRatesWithInclusions = 'spp_uplift_lpc_rates_with_inclusions',
  sppMultiIndividualRoom = 'spp_multi_individual_room',
  hotelPropertyTypeFilter = 'hotel_property_type_filter',
}
